import AccessTrailerPlayer from './AccessTrailerPlayer';

export default AccessTrailerPlayer;
